import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../auth';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { API } from '../config';

const HitCard = ({hit, activeTrades}) => {

    return (
		   <div className="group relative bg-white border border-gray-100 rounded-md flex flex-col overflow-hidden">
              <div className="aspect-w-1 aspect-h-1 bg-gray-100 group-hover:opacity-75 ">
                  <img 
                      src={`${API}/static/product_photos/${hit.primary_photo}`}
                      alt={hit.name}
                      className='object-center object-cover p-1'
                  />
              </div>
              <div className="flex justify-between plex-0 p-4">
                <div>
                  <h3 className="text-sm text-gray-700">
                    <a href={`/loot/${hit.objectID}`}>
                      <span aria-hidden="true" className="absolute inset-0" />
                      {hit.brand} | {hit.name}
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-500">{hit.condition}</p>
                </div>
                <p className="text-sm font-medium text-gray-900">${hit.price}</p>
              </div>
            </div> 
    );

};

export default HitCard;
